import $ from 'jquery';
import template from 'lodash/template';

const TRANSLATIONS = {
  de: {
    date: 'Datum',
    value: 'Wert',
  },
  fr: {
    date: 'Date',
    value: 'Valeur',
  },
};

const LANGUAGE = $('html').attr('lang') === 'fr' ? 'fr' : 'de';

const renderTemplate = template(`
  <table>
    <tr><th>${TRANSLATIONS[LANGUAGE].date}</th><td><%= date %></tr>
    <tr><th>${TRANSLATIONS[LANGUAGE].value}</th><td><%= value %></tr>
  </table>
`);

export const create = function(className) {
  /* See prate.scss:.prate-tooltip::before/border */
  const TOOLTIP_NOSE_SIZE = 12;

  const $TOOLTIP = $('<div>');
  $TOOLTIP.attr('class', className || 'tooltip');
  $TOOLTIP.css({ position: 'absolute' });
  $TOOLTIP.hide();
  $TOOLTIP.appendTo('.prate-chart');

  $.extend($TOOLTIP, {
    place(element, bounds) {
      this.css({
        left: bounds.x + (bounds.width / 2) - TOOLTIP_NOSE_SIZE,
        top: bounds.y - $TOOLTIP.outerHeight() - TOOLTIP_NOSE_SIZE,
      });
      return this;
    },
  });

  return $TOOLTIP;
};

export const markup = function(date, value) {
  return renderTemplate({
    date: date.format('YYYY-MM-DD'),
    value: Math.round(10 * value) / 10,
  });
};



// WEBPACK FOOTER //
// ./theme_src/js/tooltip.js